<template>
    <div class="pagination" v-if="totalPages > 1">
        <button class="btn" :disabled="currentPage === 1" @click="$emit('update:page', currentPage - 1)">
            <font-awesome-icon icon="chevron-left" />
        </button>

        <span>
            Strona {{ currentPage }} z {{ totalPages }}
        </span>

        <button class="btn" :disabled="currentPage === totalPages" @click="$emit('update:page', currentPage + 1)">
            <font-awesome-icon icon="chevron-right" />
        </button>
    </div>
</template>

<script>
export default {
    name: 'PaginationControls',
    props: {
        currentPage: {
            type: Number,
            required: true,
        },
        totalPages: {
            type: Number,
            required: true,
        },
    },
}
</script>

<style scoped lang="scss">
.pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    margin: 2rem 0;
    flex-wrap: wrap;

    span {
        font-size: 1rem;
        font-weight: 500;
        color: $color-text;
    }

    .btn {
        background: $color-primary;
        color: white;
        padding: 0.4rem 0.9rem;
        border-radius: 6px;
        font-size: 0.9rem;
        font-weight: 500;
        border: none;
        cursor: pointer;
        transition: all 0.2s ease;

        &:hover:not(:disabled) {
            background: $color-primary-dark;
        }

        &:disabled {
            background: $color-grey-light;
            color: $color-text-light;
            cursor: not-allowed;
        }

        svg {
            flex-shrink: 0;
        }
    }
}
</style>